import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { cloneDeep, isEqual } from 'lodash';

import { EmailAlertsModel } from '../models/email-alerts.model';
import { EmailValidator } from '../validators/email-validator';

@Component({
  selector: 'app-email-alerts-dialog',
  templateUrl: './email-alerts-dialog.component.html',
  styleUrls: ['./email-alerts-dialog.component.scss'],
  standalone: false,
})
export class EmailAlertsDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<EmailAlertsDialogComponent>>(MatDialogRef);
  data = inject<EmailAlertsModel>(MAT_DIALOG_DATA);
  private fb = inject(FormBuilder);

  public emailAlertsForm!: FormGroup;
  private readonly initialEmailAlertsModel: EmailAlertsModel;

  constructor() {
    const data = this.data;

    this.initialEmailAlertsModel = cloneDeep(data);
  }

  ngOnInit(): void {
    this.emailAlertsForm = this.fb.group({
      enable: this.fb.control(this.data.enable),
      carbonCopy: this.fb.control('', [EmailValidator.email()]),
      blindCarbonCopy: this.fb.control('', [EmailValidator.email()]),
    });
  }

  get carbonCopyEmails(): string[] {
    return this.data.carbonCopy;
  }

  get blindCarbonCopyEmails(): string[] {
    return this.data.blindCarbonCopy;
  }

  get enable(): FormControl {
    return this.emailAlertsForm.get('enable') as FormControl;
  }

  save(): void {
    this.dialogRef.close({ ...this.data, enable: this.enable.value });
  }

  public isSaveBtnDisabled(): boolean {
    return isEqual(
      { ...this.data, enable: this.enable.value },
      this.initialEmailAlertsModel,
    );
  }
}
